import { call, put, takeLatest } from "redux-saga/effects";
import { authAPI } from "../../../services/auth/index"
import { getAccessToekn, GET_ACCESS_TOKEN} from "../../actions/auth.action"

function* handleFetchAccessToken(action) {
  try {
    const { data : resData} = yield call(authAPI.accessToken, action.payload);
    //extract the data here     
    yield put(getAccessToekn.success({
        token:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(getAccessToekn.failure({
        token:resData?.data
  }));
  }
}

function* fetchAccessTokenSaga() {
  yield takeLatest(GET_ACCESS_TOKEN.REQUEST, handleFetchAccessToken);
}

export default fetchAccessTokenSaga;
